/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import ReactMapGL, { setRTLTextPlugin } from 'react-map-gl'
import { connect } from 'react-redux'
import * as tools from '../../../util/tools'
import config from '../../../util/config'

let mapConfig = config.mapbox.parsimap
setRTLTextPlugin(mapConfig.setRTLTextPlugin, null, true)

function MapBox(props) {
    const [viewport, setViewport] = useState(tools.initMapBox(props))
    // const changeViewport = props.changeViewport === false ? false : true

    const setViewportFunc = (location) => {
        if (location.zoom < config.mapbox.minZoom)
            location.zoom = config.mapbox.minZoom
        //  if (changeViewport) props.selectLocationAction(location)
        setViewport(location)
    }

    return (
        <ReactMapGL
            {...viewport}
            onViewportChange={(viewport) => setViewportFunc(viewport)}
            mapboxApiAccessToken={mapConfig.mapboxApiAccessToken}
            attributionControl={config.mapbox.attributionControl}
            dragRotate={config.mapbox.dragRotate}
            mapStyle={mapConfig.mapStyle}
        >
            {props.children}
        </ReactMapGL>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapBox)